import { Button, Card, Col, Container, Form, InputGroup, Row, } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { activateGeod, closeGeod } from "../../Store";
import { faEye, faUnlockAlt, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Swal from 'sweetalert2'
import { connect } from "react-redux";
import { postLogin } from "../../Service/AllLoginAPI";
import swal from "sweetalert";

const Signin = (props) => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputType = showPassword ? "text" : "password";
  const passwordIconColor = showPassword ? "#262B40" : "";

  const geodTitle = props.geod?.title;
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const loginStatus = sessionStorage.getItem("loginStatus");
    const hasToken = !!token && token !== "null" && token !== "undefined" && token !== "";
    const isLoggedStatus = loginStatus === "true" || loginStatus === true;
    if (hasToken || isLoggedStatus || geodTitle) {
      history.replace("/");
    }
  }, [history, geodTitle]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const submitLogin = async (e) => {
    try {
      e.preventDefault();
      if (username !== "" && password !== "") {
        const data = {
          username: username,
          password: password,
        };
        await postLogin((data))
          .then((result) => {
            //data store in session storage
            console.log("Login Result", result);
            sessionStorage.setItem("loginStatus", true);
            sessionStorage.setItem("token", result?.data?.jwtToken);
            sessionStorage.setItem("refreshToken", result?.data?.refreshToken);
            sessionStorage.setItem("userName", result?.data?.perList[0]?.userName);
            sessionStorage.setItem("role", result?.data?.perList[0]?.role);
            sessionStorage.setItem("pkUserId", result?.data?.perList[0]?.pkUserId);
            sessionStorage.setItem("firstName", result?.data?.perList[0]?.firstName);
            sessionStorage.setItem("lastName", result?.data?.perList[0]?.lastName);
            sessionStorage.setItem("userProfile", result?.data?.perList[0]?.userProfile);
            sessionStorage.setItem("moduleName", result?.data?.perList[0]?.moduleName);
            try {
              localStorage.setItem("userName", result?.data?.perList[0]?.userName);
              localStorage.setItem("pkUserId", result?.data?.perList[0]?.pkUserId);
              localStorage.setItem("firstName", result?.data?.perList[0]?.firstName);
            } catch (e) {}
            props.activateGeod({ title: true });
            Swal.fire({
              position: 'top-center',
              icon: 'success',
              title: 'Login Successfully...',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              history.replace("/");
            });
          })
          .catch((error) => {
            // console.log("Login Error", error);
            swal("Login Failed", "Check username and password", "error");
          });
      } else if (username === "") {
        swal("Failed", "Please enter username", "error");
      } else if (password === "") {
        swal("Failed", "Please enter password", "error");
      }
    } catch (error) {
      // console.log(error);
      swal("Failed", "Server down please try again later ", "error");
    }
  };
  return (
    <main className=" form-bg-image vh-100">
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
     
          <Row
            className="justify-content-center "
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500 cardcls">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="signinHead mb-0">Sign in to PetroPulse</h3>
                </div>
                <Form className="mt-4">
                  <Form.Group id="username" className="mb-4">
                    <Form.Label>Your User Name</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="Enter User Name"
                        onChange={(e) => setUsername(e.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Your Password</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type={passwordInputType}
                          placeholder="Enter Password"
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <InputGroup.Text
                          style={{
                            borderRight: "0.0625rem solid #d1d7e0",
                          }}
                          onClick={togglePasswordVisibility}
                        >
                          <FontAwesomeIcon
                            color={passwordIconColor}
                            icon={faEye}
                          />
                        </InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-end align-items-right mb-4">
                      <Card.Link
                        className="small text-end"
                        as={Link}
                        to={Routes.ForgotPassword.path}
                      >
                        Forgot Password?
                      </Card.Link>
                    </div>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={submitLogin}
                  >
                    SIGN IN
                  </Button>
                </Form>
                <div className="mt-3 mb-4 text-center">
                  <span className="fw-normal">
                    or login with{" "}
                    <Card.Link
                      className="small text-end"
                      as={Link}
                      to={Routes.SignMobile.path}
                    >
                      Mobile No
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => {
  return {
    geod: state.geod,
  };
};

const mapDispatchToProps = {
  activateGeod,
  closeGeod,
};

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(Signin);
export default AppContainer;
